import { render } from "./singleWithoutBoth.vue?vue&type=template&id=c13a748a&ts=true"
import script from "./singleWithoutBoth.vue?vue&type=script&lang=ts"
export * from "./singleWithoutBoth.vue?vue&type=script&lang=ts"

import "./singleWithoutBoth.vue?vue&type=style&index=0&id=c13a748a&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__